(() => {
  const init = (root) => {
    if (!root || root.dataset.maisonArticleReady === 'true') return;
    root.dataset.maisonArticleReady = 'true';

    const progress = root.querySelector('[data-maison-reading-progress]');
    const updateProgress = () => {
      if (!progress) return;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const ratio = max > 0 ? window.scrollY / max : 0;
      progress.style.transform = `scaleX(${Math.min(1, Math.max(0, ratio))})`;
    };
    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();

    const loop = root.querySelector('[data-maison-article-loop]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const saveData = navigator.connection && navigator.connection.saveData;
    if (!loop || reduced || saveData) return;

    const load = () => {
      if (loop.dataset.loaded === 'true') return;
      loop.querySelectorAll('source[data-src]').forEach((source) => { source.src = source.dataset.src; });
      loop.dataset.loaded = 'true';
      loop.load();
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            load();
            loop.play().catch(() => {});
          } else {
            loop.pause();
          }
        });
      }, { rootMargin: '220px 0px', threshold: 0.05 });
      observer.observe(loop);
    } else {
      load();
    }
  };

  const initAll = (scope = document) => scope.querySelectorAll('[data-maison-journal-article]').forEach(init);
  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
